import React from "react";

const Stat_Median = () => {
  return (
    <div>
      <h1>Stat Median</h1>
    </div>
  );
};

export default Stat_Median;
